import { cloneElement } from 'react'

import { transparentize } from 'polished'
import styled from 'styled-components'

import { ButtonAsync, withFocusVisible } from '@subaio/components'

import { theme } from '../../../styles/theme'
import { focusVisibleOutline } from '../../FocusVisible'
import { Wrapper } from './Wrapper'

type Props = {
	fullWidth?: boolean
	icon: React.JSX.Element
	removeAlignment?: boolean
	size?: number
	isFocusVisible: boolean
}

export const ButtonIcon = withFocusVisible(styled(ButtonAsync).attrs<Props>(({ icon, size = 20, removeAlignment }) => ({
	label:
		icon && removeAlignment ? (
			cloneElement(icon, { size })
		) : (
			<Wrapper fixAlignment={size < 20}>{cloneElement(icon, { size })}</Wrapper>
		),
}))`
	color: ${theme.color.button.background};
	min-width: initial;
	width: 30px;
	height: 30px;
	padding: 0;
	margin: 0 6px 0 0;
	border-radius: 4px;
	transition: color 0.2s, background-color 0.2s, border-color 0.2s;
	isolation: isolate;
	flex-shrink: 0;
	background-color: ${transparentize(0.95, theme.color.button.background)};

	&:is(:focus-visible, :hover) {
		background-color: ${theme.color.button.backgroundTranslucent};
	}

	&:disabled {
		color: ${theme.color.text};
		background-color: ${transparentize(0.86, theme.color.text)};
	}

	${focusVisibleOutline}

	&:after {
		content: '';
		display: block;
		position: absolute;
		width: 100%;
		height: 100%;
		top: 0;
		left: 0;
		pointer-events: none;
		background-image: radial-gradient(circle, ${theme.color.button.background} 16%, transparent 16.01%);
		background-repeat: no-repeat;
		background-position: 50%;
		transform: scale(10, 10);
		opacity: 0;
		transition: transform 0.7s, opacity 0.9s;
	}

	&:active:after {
		transform: scale(0, 0);
		opacity: 0.2;
		transition: 0s;
	}

	&:disabled:after {
		opacity: 0;
	}
`)
